import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { useSearchParams, useParams } from 'react-router-dom';

import { isSqlIDE } from '../isSqlIDE';
import { Private_Routes } from '../url';

export function useIDEParamsForIDEPage() {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.IDE.url>>();
  const uid = params.uid as string;
  const [searchParams] = useSearchParams();
  const entity = (isSqlIDE() ? searchParams.get('entity')?.toLowerCase() : params.entity) as string;

  const branch = searchParams.get('branch') as string;
  const pipelineRunId = searchParams.get('run-id') as string;
  const projectId = searchParams.get('projectId') as string;
  const action = searchParams.get('action') as string;

  const gemId = searchParams.get('gemId') as string;
  const observedEntity = searchParams.get('observedEntity') as string | undefined;
  const transpilerVersion = searchParams.get('transpilerVersion') as string;
  const transpilerSource = searchParams.get('transpilerSource') as string;
  const transpilerId = searchParams.get('transpilerId') as string;
  const transpilerGemId = searchParams.get('transpilerGemId') as string;
  return {
    uid,
    entity,
    branch,
    'run-id': pipelineRunId,
    projectId,
    action,
    transpilerGemId,
    gemId,
    observedEntity,
    transpilerVersion,
    transpilerSource,
    transpilerId
  };
}
